import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialMediumSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M13.41 12c0 3.45-2.779 6.247-6.205 6.247S1 15.45 1 12s2.778-6.247 6.205-6.247S13.409 8.55 13.409 12m6.807 0c0 3.248-1.39 5.88-3.102 5.88S14.01 15.249 14.01 12s1.39-5.88 3.103-5.88 3.102 2.632 3.102 5.88M23 12c0 2.91-.488 5.269-1.091 5.269s-1.091-2.36-1.091-5.269.488-5.269 1.09-5.269S23 9.091 23 12" }),
      /* @__PURE__ */ jsx("path", { fill: "none", d: "M22.98 6.104v11.755H1.032V6.104H22.98Z" })
    ]
  }
);
export {
  IconSocialMediumSvg
};
